import "./CreateModal.scss";

import PropTypes from "prop-types";

import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "shared/src/stores/storeConnect";
import { trackCreateList } from "shared/src/tracking/ListTrackingUtil";
import ListVisibilityChanger from "../../../general/ListVisibilityChanger";
import { Modal, Button, Checkbox } from "react-bootstrap";
import SessionStore from "shared/src/stores/SessionStore";
import { SessionStore as ActualSessionStore } from "shared/src/uidispatcherapi/SessionStore";

type Props = {
    createNewList: (name: string, globallyVisible: boolean, readOnlyForEmployees: boolean) => void;
    onClose: () => void;
    show: boolean;
    globallyVisible: boolean;
    selectedDeliveryAddress: {
        [x: string]: any;
    };
    container: React.Component<any>;
};

type State = {
    globallyVisible: boolean;
    readOnlyForEmployees: boolean;
    listName: string | undefined | null;
};

class CreateModal extends React.Component<Props, State> {
    static contextTypes = {
        intl: PropTypes.object
    };

    state = {
        globallyVisible: this.props.globallyVisible,
        readOnlyForEmployees: false as boolean,
        listName: null as string | null
    };

    handleSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        if (this.state.listName && this.state.listName !== "") {
            this.props.createNewList(this.state.listName, this.state.globallyVisible, this.state.readOnlyForEmployees);
            trackCreateList(this.state.globallyVisible, this.state.readOnlyForEmployees);
        }
        this.props.onClose();
        return false;
    };

    handleListChangeName = (e: React.SyntheticEvent) => {
        this.setState({
            listName: (e.target as any).value
        });
    };

    changeVisibility = (event: React.SyntheticEvent) => {
        this.setState({ globallyVisible: (event.target as any).value === "globallyVisible" });
    };

    changeReadOnlyForEmployees = () => {
        this.setState({
            readOnlyForEmployees: !this.state.readOnlyForEmployees
        });
    };

    render() {
        // Allow user to make new list non globally visible only if a delivery address is selected.
        const showGloballyVisibleChanger =
            this.props.selectedDeliveryAddress !== null && this.props.selectedDeliveryAddress !== undefined;

        return (
            <Modal
                container={this.props.container}
                keyboard
                animation
                onHide={this.props.onClose}
                show={this.props.show}
                className="ca-list-create-modal">
                <Modal.Header closeButton>
                    <Modal.Title>{<FormattedMessage id="ORC_CREATE_NEW_LIST" />}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form role="form" onSubmit={this.handleSubmit}>
                        <div className="form-group">
                            <input
                                type="text"
                                maxLength={40}
                                className="form-control"
                                autoFocus
                                placeholder={this.context.intl.formatMessage({ id: "ORC_NAME_YOUR_LIST" })}
                                onChange={this.handleListChangeName}
                            />
                        </div>
                        <div className="form-group">
                            <ListVisibilityChanger
                                initialValue={this.state.globallyVisible}
                                showGloballyVisibleChanger={showGloballyVisibleChanger}
                                isGloballyVisibleChangerActive
                                changeVisibility={this.changeVisibility}
                            />
                        </div>
                        {ActualSessionStore.isCustomer() && (
                            <Checkbox
                                checked={this.state.readOnlyForEmployees}
                                onChange={this.changeReadOnlyForEmployees}>
                                <FormattedMessage
                                    className="checkbox-label"
                                    id="EX_LIST_CREATE_EDIT_MODAL_RESTRICT_EMPLOYEE_EDITING"
                                />
                            </Checkbox>
                        )}
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.onClose}>
                        <FormattedMessage id="EX_CANCEL_MODAL" />
                    </Button>
                    <button
                        type="submit"
                        value="create"
                        className="btn btn-primary test-create-list"
                        onClick={this.handleSubmit}>
                        <FormattedMessage id="ORC_SAVE_NEW_LIST" />
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

const CreateModalWrapper = connect(
    {
        stores: [[SessionStore, ["selectedDeliveryAddress"]]]
    },
    CreateModal
);

type TriggerProps = {
    createNewList: (name: string, globallyVisible: boolean, readOnlyForEmployees: boolean) => void;
    children: {
        [x: string]: any;
    };
};

type TriggerState = {
    showModal: boolean;
};

class CreateModalTrigger extends React.Component<TriggerProps, TriggerState> {
    state = { showModal: false };

    close = () => {
        this.setState({ showModal: false });
    };

    open = () => {
        this.setState({ showModal: true });
    };

    render() {
        return (
            <div>
                <div onClick={this.open}>{this.props.children}</div>
                <CreateModalWrapper
                    container={this}
                    createNewList={this.props.createNewList}
                    show={this.state.showModal}
                    onClose={this.close}
                />
            </div>
        );
    }
}

(CreateModalWrapper as any).Trigger = CreateModalTrigger;

export default CreateModalWrapper;
export { CreateModalTrigger as Trigger };
